export default "__VITE_ASSET__34c8f178__"